import { __decorate, __metadata, __param } from "tslib";
import { Symbols } from '@/symbols';
import { inject, injectable } from 'inversify';
let OperationService = class OperationService {
    constructor(MarketplaceApi) {
        this.MarketplaceApi = MarketplaceApi;
    }
    /**  统计购买,订阅,访问代理所统计信息 */
    postPlatformSummary(params) {
        return this.MarketplaceApi.postPlatformSummary(params).then(res => res.data);
    }
    postPlatformOrder(params) {
        return this.MarketplaceApi.postPlatformOrder(params).then(res => res.data);
    }
    postPlatformAccess(params) {
        return this.MarketplaceApi.postPlatformAccess(params).then(res => res.data);
    }
    /** 导出 */
    postPlatformExport(params) {
        return this.MarketplaceApi.postPlatformExport(params);
    }
};
OperationService = __decorate([
    injectable(),
    __param(0, inject(Symbols.MarketplaceApi)),
    __metadata("design:paramtypes", [Object])
], OperationService);
export { OperationService };
